<div class="main-container lg-view" *ngIf="!isLoading">
    <h3>Add Comment for rejecting form validations skip</h3>

    <div class="main-form">
        <form [formGroup]="formModel">
            <fieldset>
                <mat-form-field>
                    <mat-label>Comment</mat-label>
                    <textarea matInput formControlName="comment" rows="9"></textarea>
                </mat-form-field>
            </fieldset>
        </form>
    </div>

    <generic-modal #procedureFormValidationsSkipResponseModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form validations skip request</h3>
        </ng-template>

        <ng-template #modalBody>
            <div style="text-align: center;">
                <h4 style="margin-top: 0;">was successfully rejected</h4>
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormValidationsSkipResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

    <generic-modal #procedureFormValidationsSkipResponseModalError>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form validations skip request could not be processed</h3>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormValidationsSkipResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>
</div>


<div class="actions-container  md-view" *ngIf="!isLoading">
    <ng-container>
        <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
        <action-button [icon]=" ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitComment.bind(self)"
                       [disabled]="formModel.invalid"></action-button>
    </ng-container>
</div>
